<template>
    <div class="otoast-container">
        <transition-group name="toast-list" tag="div">
            <OToast
                v-for="toast in toasts"
                :key="toast.id"
                :type="toast.type"
                :title="toast.title"
                :message="toast.message"
                :duration="toast.duration"
                @close="removeToast(toast.id)"
            />
        </transition-group>
    </div>
</template>

<script>
import OToast from './OToast.vue'

/**
 * OToastContainer manages the positioning and rendering of multiple OToast components.
 * It receives a list of toasts and handles their removal.
 */
export default {
    name: 'OToastContainer',
    components: { OToast },
    props: {
        /**
         * An array of toast objects to be displayed.
         */
        toasts: {
            type: Array,
            required: true,
        },
    },
    /**
     * Emitted when a toast requests to be removed.
     * The payload is the ID of the toast to remove.
     */
    emits: ['remove'],
    setup(props, { emit }) {
        function removeToast(id) {
            emit('remove', id)
        }

        return {
            removeToast,
        }
    },
}
</script>

<style scoped>
.otoast-container {
    position: fixed;
    top: 1rem;
    right: 1rem;
    z-index: 99999;
    pointer-events: none;
}

.toast-list-enter-active,
.toast-list-leave-active {
    transition: all 0.5s ease;
}
.toast-list-enter-from,
.toast-list-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
.toast-list-move {
    transition: transform 0.5s ease;
}
</style>